import React from "react";
import Hero from "./Hero";
import Home1 from "./Home1";
import Home2 from "./Home2";
import Home3 from "./Home3";
import Home4 from "./Home4";
import Home5 from "./Home5";

const Home = () => {
  return (
    <>
      <Hero />
      <Home1 />
      <Home2 />
      <Home3 />
      <Home4 />
      <Home5 />
    </>
  );
};

export default Home;
